import { Pages } from 'modules/navigation/domain/enums/pages';
import React, { useEffect, useMemo } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { checkIsDev } from 'shared/utils/check-is-dev';
import UDHeaderTitle from 'ud-ui/components/header-title';
import { TabMenu } from 'ud-ui/components/tab-menu';
import UDText from 'ud-ui/components/text';
import { useMainLayout } from 'modules/app-shell/ui/layout/context';
import Experiments from './tabs/experiments/experiments';
import Profile from './tabs/profile/profile';
import SocialNet from './tabs/social-net/social-net';
import Subscription from './tabs/subscription/subscription';

interface SettingsTab {
  name: string;
  /** Адрес вкладки из `Pages`. */
  path: string;
  /** Хвост адреса, по которому вкладка считается активной; у первой его нет. */
  match?: string;
}

const BASE_TABS: SettingsTab[] = [
  { name: 'Профиль', path: Pages.SETTINGS.INDEX },
  { name: 'Ссылки', path: Pages.SETTINGS.SOCIAL_NET, match: '/social-net' },
  { name: 'Подписка', path: Pages.SETTINGS.SUBSCRIPTION, match: '/subscription' },
];

const EXPERIMENTS_TAB: SettingsTab = { name: 'Эксперименты', path: Pages.SETTINGS.EXPERIMENTS, match: '/experiments' };

const SettingsPage = () => {
  const { setHeaderContent } = useMainLayout();
  const navigate = useNavigate();
  const location = useLocation();

  // Вкладка и её роут существуют только вне прода: `checkIsDev()` там всегда false.
  const isDev = useMemo(() => checkIsDev(), []);
  const tabs = useMemo(() => (isDev ? [...BASE_TABS, EXPERIMENTS_TAB] : BASE_TABS), [isDev]);

  const activeTab = useMemo(() => {
    const index = tabs.findIndex((tab) => tab.match && location.pathname.includes(tab.match));

    return index === -1 ? 0 : index;
  }, [location.pathname, tabs]);

  useEffect(() => {
    setHeaderContent(<UDHeaderTitle>Настройки</UDHeaderTitle>);

    return () => {
      setHeaderContent(null);
    };
  }, [setHeaderContent]);

  const changeTab = (tab: number) => {
    navigate(tabs[tab]?.path ?? Pages.SETTINGS.INDEX);
  };

  return (
    <>
      <div className="w-full px-6 py-6">
        <UDText type="headline" className="mr-10">
          Информация об организаторе
        </UDText>
      </div>
      <div>
        <TabMenu tabs={tabs.map((tab) => ({ name: tab.name, active: true }))} activeTab={activeTab} onChange={changeTab} />
      </div>
      <div className="w-full px-6 py-6">
        <Routes>
          <Route path="/" element={<Profile />} />
          <Route path="/social-net" element={<SocialNet />} />
          <Route path="/subscription" element={<Subscription />} />
          {isDev && <Route path="/experiments" element={<Experiments />} />}
        </Routes>
      </div>
    </>
  );
};

export default SettingsPage;
